import * as React from 'react';
import {
    getItemSummaryCatalogTitle,
    getItemSummaryLotNumber,
    getItemSummarySellerName,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { getLiveCatalogCurrentItemId } from '@/redux/modules/console';
import { openSendSellerMessageModal } from '@/redux/modules/modal';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import AuctioneerInfo from '@/components/AuctioneerInfo/AuctioneerInfo';

type Props = {
    catalogId: number;
    className?: string;
    sellerId: number;
};

const AuctioneerDetails = ({ catalogId, className, sellerId }: Props) => {
    const dispatch = useAppDispatch();
    const itemId = useAppSelector((state) => getLiveCatalogCurrentItemId(state, catalogId));
    const lotNumber = useAppSelector((state) => getItemSummaryLotNumber(state, itemId));
    const catalogTitle = useAppSelector((state) => getItemSummaryCatalogTitle(state, itemId));
    const sellerName = useAppSelector((state) => getItemSummarySellerName(state, itemId));

    const showSendSellerMessageModal = React.useCallback(() => {
        const messageDetails = {
            catalogId,
            itemId,
            lotNumber: lotNumber,
            title: catalogTitle,
        };

        dispatch(openSendSellerMessageModal(messageDetails, sellerId, sellerName, catalogTitle));
    }, [catalogId, catalogTitle, dispatch, itemId, lotNumber, sellerId, sellerName]);

    return (
        <AuctioneerInfo
            className={className}
            sellerId={sellerId}
            showSendSellerMessageModal={showSendSellerMessageModal}
        />
    );
};

export default AuctioneerDetails;
